import toastr from 'toastr';
import axios from 'axios';
import router from './index.js';
import store from '../store/index';
import cookie from 'vue-cookie';
import logoutService from '../shared/logout-service';
import i18n from '@/i18n.bootstrap';

let toRoute = null;

const toNoAuth = ['login', 'share-file', 'error-page'];
const noRedirect = ['invite', 'dashboard', ...toNoAuth];

router.beforeEach((to, from, next) => {

    toRoute = to;

    if(
       !noRedirect.includes(to.name) && 
       !cookie.get('EPR_INVITE')) {
        
        store.dispatch('system/setRedirectInfo', to);
    }

    if (!toNoAuth.includes(to.name) && !store.getters['userData/isUserLoggedIn']) {
        if (to.name === 'invite' && !store.getters['system/invite']) {
            store.dispatch('system/setInvite', to.params.token);
            cookie.set('EPR_INVITE', to.params.token, 1);
        }

        store.dispatch('userData/loadUserData', loggedIn => {
            if (loggedIn) {
                if (cookie.get('EPR_INVITE')) {
                    next({
                        name: 'invite',
                        params: { token: cookie.get('EPR_INVITE') }
                    });
                } else if(store.getters['system/redirectInfo']) {
                    let redirectInfo = store.getters['system/redirectInfo'];

                    next({
                        name: redirectInfo.name,
                        params: redirectInfo.params,
                        query: redirectInfo.query
                    });
                    
                    store.dispatch('system/setRedirectInfo', undefined);
                } else {
                    next();
                }
            } else {
                next('/login');
            }
        });
    } else if (
        store.getters['userData/isUserLoggedIn'] &&
        !to.name &&
        to.name !== 'invite' &&
        cookie.get('EPR_INVITE')
    ) {
        next({ name: 'invite', params: { token: cookie.get('EPR_INVITE') } });
    } else {
        next();
    }
});

axios.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        if (!error || !error.response) {
            return;
        }
        if (error.response.status === 401) {
            if (error.response.data.type === 'WRONG_LOGIN') {
                toastr.error(i18n.t('login.validation.wrongLogin'));
            } else if (router.history.pending && router.history.pending.name === 'invite') {
                toastr.info(i18n.t('general.loginFirst'));
            } else {
                toastr.info(i18n.t('general.sessionExpired'));
                logoutService.logout();
                return;
            }
        } else if (error.response.status === 403) {
            if (error.response.data.type === 'WRONG_LOGIN') {
                toastr.error(i18n.t('login.validation.wrongLogin'));
            } else if (error.response.data.type === 'NOT_AUTHENTICATED') {
                toastr.info(i18n.t('general.sessionExpired'));
                logoutService.logout();
            } else {
                toastr.error(i18n.t('general.forbidden'));
                router.replace({ name: 'dashboard' });
                return;
            }
        } else if (error.response.status === 404) {
            let errorMessage;
            let loggedInUser = store.getters['userData/isUserLoggedIn'];
            let redirectRoute = (loggedInUser || error.response.data.type === 'OBJECT_NOT_FOUND') ? 'error-page' : 'login';

            if (error.response.data.type === 'SHARE_NOT_FOUND') {
                errorMessage = i18n.t('share.notFound');
            } else if (error.response.data.type === 'OBJECT_NOT_FOUND') {
                let fileId = error.response.data.message.match(/\d/g).join('');
                errorMessage = i18n.t('general.errorPage.objectNotFound', { fileId });
                if (toRoute.name === 'project-room-creator') {
                    toastr.error(errorMessage);
                    return;
                }
            } else if (error.response.data.type === 'INVITATION_NOT_FOUND') {
                errorMessage = i18n.t('project.invitation.action.errorInvalidInvite');
            } else if (error.response.data.type === 'INVITATION_EXPIRED') {
                errorMessage = i18n.t('project.invitation.action.errorExpiredInvite');
            }
            router.push({ name: redirectRoute, params: { errorMessage }});
        } else if (error.response.status === 500) {
            if (error.response.data.type === 'UNSPECIFIC_ERROR') {
                toastr.error(i18n.t('general.serverError', { code: error.response.status}));
            } else {
                toastr.error(error.response.data.message);
            }
        } else if (error.response.status === 422) {
            if (error.response.data.type !== 'FOLDER_OR_REGISTER_NOT_AVAILABLE') {
                toastr.error(error.response.data.message);
            }
        }

        return Promise.reject(error);
    }
);
